/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Col_ProviderInputs */

const cs_signing_col_provider = /** @type {(inputs: Signing_Col_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poskytovatel`)
};

const en_signing_col_provider = /** @type {(inputs: Signing_Col_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Signing_Col_ProviderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_col_provider = /** @type {((inputs?: Signing_Col_ProviderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Col_ProviderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_col_provider(inputs)
	return cs_signing_col_provider(inputs)
});